import VideoTranscripts from '../../../common/videos/transcripts.js';
import StatusMessages from '../../../common/helpers/statusmessage.js';

class WhyWorkVideo{
    constructor(){
        this.player = null;
        // NOTE: why buy ID is also stored in locale key: infopages > employment
        this.whyWorkID = "3e8cba4a-f0f5-4d34-819e-c221131719bf";
        this.transcriptTextURL = `https://cdn.4imprint.com/vid/captions/${this.whyWorkID}.txt`;
        this.streamURL = `https://cdnv.4imprint.com/encoded/${this.whyWorkID}/stream.mpd`;
        this.indexURL = `https://cdnv.4imprint.com/encoded/${this.whyWorkID}/index.m3u8`;
        this.subTitleURL = `https://cdn.4imprint.com/vid/captions/${this.whyWorkID}.vtt`;
        this.thumbnailURL = `https://cdnv.4imprint.com/encoded/${this.whyWorkID}/sprites/low/sprite.vtt`;
        this.title = "Why Work at 4imprint";
        this.startPlayback = false;
        this.playerDiv = document.getElementById("player");
        this.transcriptContainer = document.getElementById("transcriptContainer");
    }

    async init(startPlayback = false) {
        this.startPlayback = startPlayback;
        const source = await this.getSource();
        await this.playVideo(source);
    }

    async getSource() {
       return {
            title: this.title,
            dash: this.streamURL,
            hls: this.indexURL,
            subtitleTracks: [{
                url: this.subTitleURL,
                id: 'track-0',
                label: 'English',
                lang: 'en'
            }],
            thumbnailTrack: {
                url: this.thumbnailURL
            }
        };
    }

    async playVideo(config) {
        const playerConfig = {
            key: 'a8072f85-5072-454b-b8f2-09087b192aa7',
            analytics: {
                key: '26a9da30-39dd-4906-bf18-2b222b809d92',
                title: this.title,
                videoId: this.whyWorkID,
            }
        };
        if(this.player) await this.player.destroy();
        this.player = new bitmovin.player.Player(this.playerDiv, playerConfig);
        await this.player.load(config);
        await this.getTranscript();
        // seems like if the page loads with autoplay set to false, it ignores that on any other videos and you need to call play()
        if(this.startPlayback) this.player.play(); 
	}

    async getTranscript() {
        StatusMessages.clear();
		try{
			const response = await fetch(this.transcriptTextURL, {
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			const responseText = await response.text();
            if(responseText && responseText != ""){
                this.transcriptContainer.innerHTML =  '<p class="text16">' + responseText + '</p>';
                VideoTranscripts.init();
            }else {
                this.showError();
            }
		}catch(error){
			console.error(error);
			this.showError();
		}
	}

    showError() {
        StatusMessages.showError(this.transcriptContainer, "Oops, looks like there was either a problem getting the transcript or we may not have one completed yet.");
    }
}

export default new WhyWorkVideo();